export default "__VITE_ASSET__BpUV6scQ__"